import { API_ROOT } from '../../config/config'
import { doDownload, doGet, doPost, doPostFiles } from './utils'

//หลายโครงการ
//บันทึกวิธีการกลั่นกรอง page
export const getScrutinizeSchemaMulti = (request) => {
  const url = `${API_ROOT}/multiple/scrutinize/page`
  // return doGet(url, request)
  return doPost(url, request)
}

export const saveScrutinizeMulti = (request) => {
  const url = `${API_ROOT}/multiple/scrutinize/add/`
  return doPostFiles(url, request)
}

export const getScrutinizeAttachmentMulti = (projectVersionIds, fileId) => {
  const url = `${API_ROOT}/multiple/scrutinize/download/projectversionid/${projectVersionIds}/fileid/${fileId}`
  return doDownload(url)
}
